import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import ActivityArea from '../activityArea';

/**
 * 定义 右侧图文 组件
 */

class SiderBarArticle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    render() {
        const { content } = this.props;

        return (
            <div className={styles.sideBar}>
                <a href="http://finance.ifeng.com/listpage/838/1/list.shtml">
                    <div className={styles.h2wrapper}>
                        <h2>活动专区</h2>
                    </div>
                </a>
                <ActivityArea content={content} />
            </div>
        );
    }
}

SiderBarArticle.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(SiderBarArticle);
